export default __webpack_public_path__ + "static/media/CORE_GLI.c6b0f4f2.png";